import "./SectionUsersSidebarPanel.scss";

import type { FC, ReactNode } from "react";

import { CourseUserCard } from "./SectionUserCard";

import type { SectionRoleType } from "components/server-types";
import { t } from "i18n/i18n";
import { PersonJoinedIcon } from "mds/icons";
import { SectionUserActivityStatus, EnhancedUserWithSectionActivity } from "store/selectors";
import { getCourseResourceRole } from "utils/section";

interface CourseRoleCardProps {
  courseRole: SectionRoleType;
  users: EnhancedUserWithSectionActivity[];
  className?: string;
  canModifyUsers?: boolean;
  headerIcon?: ReactNode;
  separateUsersInClassSession?: boolean;
  showEmpty?: boolean;
  showOnlineCount?: boolean;
  startOpen?: boolean;
}

export const CourseRoleCard: FC<CourseRoleCardProps> = ({
  courseRole,
  users,
  className,
  canModifyUsers = false,
  headerIcon,
  separateUsersInClassSession = false,
  showEmpty = false,
  showOnlineCount = false,
  startOpen = false,
}) => {
  const usersInRole = users.filter((user) => user.role === courseRole && !user.is_disabled);
  const onlineUsers = usersInRole.filter(
    (user) => user.courseActivityStatus !== SectionUserActivityStatus.OFFLINE,
  );
  const role = getCourseResourceRole(courseRole);

  return (
    <CourseUserCard
      canModifyUsers={canModifyUsers}
      className={className}
      filterUsers={(allUsers) =>
        allUsers.filter((user) => user.role === courseRole && !user.is_disabled)
      }
      headerCount={
        showOnlineCount ? `${onlineUsers.length}/${usersInRole.length}` : `${usersInRole.length}`
      }
      headerIcon={
        headerIcon || (
          <PersonJoinedIcon size="xs" statusColor={onlineUsers.length > 0 ? "green" : "gray"} />
        )
      }
      headerTitle={t(`roles.course_${role}_plural`)}
      separateUsersInClassSession={separateUsersInClassSession}
      showEmpty={showEmpty}
      startOpen={startOpen}
      users={users}
    />
  );
};
